<template>
  <div class="table-responsive">
    <table class="table table-hover">
        <thead>
            <tr>
                <th v-for="key in columns"
                    @click="sortBy(key)"
                    :class="{ active: sortKey == key }">
                    {{ key | capitalize }}
                    <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
                    </span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="entry in filteredData">
                <td>{{entry.name}}</td>
                <td>{{entry.groups}}</td>
                <td>{{entry.total}}</td>
                <td>{{entry.allocated}}</td>
                <td>
                  <div class="percentage_container">
                    <div class="percentage_text">{{percentageallocated_width(entry).slice(0, 2).replace(".", "")}}%</div>
                    <div class="percentage_box">
                      <div class="percentage_bar" :style="{width: percentageallocated_width(entry)}"></div>
                    </div>
                  </div>
                </td>
                <td>{{entry.instock}}</td>
                <td>
                  <div class="percentage_container">
                    <div class="percentage_text">{{percentageinstock_width(entry).slice(0, 2).replace(".", "")}}%</div>
                    <div class="percentage_box">
                      <div class="percentage_bar" :style="{width: percentageinstock_width(entry)}"></div>
                    </div>
                  </div>
                </td>
                <td>{{entry.location}}</td>
                <td><router-link class="btn btn-default" :to="'/inventory/assets/' + entry['.key']">More</router-link></td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'assetstable',
   props: {
    data: Array,
    columns: Array,
    filterKey: String,
    url: String
  },
  created:function(){

  },
  data: function () {
    var sortOrders = {}
    this.columns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders
    }
  },
  computed: {
    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    },
    percentageallocated_width: function (entry) {
      return entry.allocated / entry.total * 100 + '%'
    },
    percentageinstock_width: function (entry) {
      return entry.instock / entry.total * 100 + '%'
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {box-sizing: border-box}

.percentage_box {
  width: 100%;
  background-color: rgb(204, 204, 204);
  border-radius: 5px;
  height: 16px;
}

.percentage_bar {
  text-align: right;
  color: white;
  background-color: #007BFF;
  margin-top: 5px;
  border-radius: 5px;
  height: 16px;
}

.percentage_text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
}

.percentage_container {
  position: relative;
  text-align: center;
  color: white;
}

.dropdown {
  margin-right: default
}
th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}
</style>



// WEBPACK FOOTER //
// AssetsTable.vue?733552fe